import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import HomePage from "../components/HomePage";
import NotFoundPage from "../components/NotFoundPage";
import LoginPage from "../components/LoginPage";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Admin from "../components/Admin";
import Contact from "../components/Contact";
import About from "../components/About";
import Reference from "../components/Reference";

export const history = createHistory();

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Switch>
        <PublicRoute path="/" component={HomePage} exact />
        <PublicRoute path="/ref" component={Reference} />
        <PublicRoute path="/login" component={LoginPage} />
        <PublicRoute path="/contact" component={Contact} />
        <PublicRoute path="/about" component={About} />
        <PrivateRoute path="/admin" component={Admin} />
        <Route component={NotFoundPage} />
      </Switch>
    </div>
  </Router>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js